import React from 'react';

import { BrancheDto } from 'lib_api/lib/api/gen';

import { FieldDisplay } from 'components/FieldDisplay/FieldDisplay';
import BaseModal from 'components/WrappedComponents/BaseModal';
import { BaseModalWidthUtils } from 'utils/BaseModalWidthUtils';
import { LABEL_ID_CORRELATION } from 'utils/global';

interface ModalDetailsProps {
  branche: BrancheDto;
  visible: boolean;
  close: () => void;
}

function ModalDetails({
  branche,
  visible,
  close,
}: ModalDetailsProps): React.ReactElement {
  return (
    <BaseModal
      width={BaseModalWidthUtils.xLargeWidth}
      isVisible={visible}
      closeModal={close}
      className="modalDetails"
    >
      <>
        <FieldDisplay
          label={LABEL_ID_CORRELATION}
          value={branche.idCorrelation}
        />
        <FieldDisplay label="Nature" value={branche.nature} />
        <FieldDisplay label="Branche" value={branche.branche} />
      </>
    </BaseModal>
  );
}

export default ModalDetails;
